__turbopack_context__.v({
  "backdrop": "Dialog-module__taZUqa__backdrop",
  "body": "Dialog-module__taZUqa__body",
  "close": "Dialog-module__taZUqa__close",
  "content": "Dialog-module__taZUqa__content",
  "description": "Dialog-module__taZUqa__description",
  "footer": "Dialog-module__taZUqa__footer",
  "header": "Dialog-module__taZUqa__header",
  "size-full": "Dialog-module__taZUqa__size-full",
  "size-lg": "Dialog-module__taZUqa__size-lg",
  "size-md": "Dialog-module__taZUqa__size-md",
  "size-sm": "Dialog-module__taZUqa__size-sm",
  "size-xl": "Dialog-module__taZUqa__size-xl",
  "title": "Dialog-module__taZUqa__title",
});
